<div id="viewGtinDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;position:absolute !important" appDraggable dragTarget="#viewGtinDialog" dragHandle="#gtinPercentDialogHeader">
  <div class="modal-content">
    <div class="modal-header" id="gtinPercentDialogHeader">
		<button type="button" class="close" data-dismiss="modal" (click)="hide()"><i class="fa fa-times" aria-hidden="true"></i></button>
		<h4 class="modal-title"><i class="fa fa-refresh"></i> VIEWING SET: {{name}}</h4>
    </div>
    <div class="modal-body internal-well">
		<div class="tab-content">
		<div class="page-button">
			<!--Add Button -->
			<button (click)="addClicked()" class="btn btn-ef" type="button"><i class="fa fa-plus" aria-hidden="true"></i>
			ADD NEW</button>
			
			<!-- Filter -->
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li (click)="setFilterViewGtinValidationSet(null, null)"><a>REMOVE FILTER</a></li>
				<li (click)="setFilterViewGtinValidationSet('GTIN-14', 'gtin14')"><a>GTIN-14</a></li>
			</ul>
		</div>
		<div *ngIf="filterColumnViewGtin != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			{{ filterColumnNameViewGtin }}
		</div>
		<div *ngIf="filterColumnViewGtin != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				[(ngModel)]="filterStringViewGtin" (ngModelChange)="filterStringChangedViewGtin()">
		</div>
			
			<!-- RESULTS PER PAGE -->
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
					<em class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span>
				</button>
				<ul class="dropdown-menu">
					<li *ngFor="let value of resultsPerPageValues" (click)="updateResultsPerPageValue(value)"
						[class.active]="value === selectedPageSizeValueForViewGtin"
						>
						<a>{{ value }}</a>
					</li>
				</ul>
			</div>
		</div>
    <table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid" role="grid">
			<thead>
				<tr role="row" class="tablesorter-headerRow">
					<th></th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="gtin14" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
						aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Gtin14: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">GTIN-14</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="minpercentage" data-sortable="true" data-column="2" tabindex="0" scope="col" role="columnheader"
						aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="MinPercentage: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">PERCENTAGE UNDER</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="maxpercentage" data-sortable="true" data-column="2" tabindex="0" scope="col" role="columnheader"
						aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="MaxPercentage: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">PERCENTAGE OVER</div>
					</th>
          
				</tr>
			</thead>
			<tbody aria-live="polite" aria-relevant="all">
				<ng-container
					*ngFor="let gtinDetails of gtinDetails | paginate: {id: 'gtin_view_pagination', itemsPerPage: selectedPageSizeValueForViewGtin, currentPage: currentPageForViewGtin, totalItems: totalNumberOfViewGtin }">
					<tr>
						<td><em class="fa fa-trash" (click)="deleteRowClicked(gtinDetails)" ></em>&nbsp;&nbsp;&nbsp;<em class="fa fa-pencil" (click)="editRowClicked(gtinDetails)"></em></td>
						<td>{{ gtinDetails.gtin14 }}</td>
						<td>{{ gtinDetails.minPercentage }}</td>
						<td>{{ gtinDetails.maxPercentage }}</td>
						
					</tr>
				</ng-container>
			</tbody>
    </table>
	<pagination-controls class="pagination" id="gtin_view_pagination" (pageChange)="pageChanged($event)" [directionLinks]="true"
			nextLabel="Next" previousLabel="Prev" [autoHide]="true">
		</pagination-controls>
    </div>

    <div class="modal-footer">
		<button type="button" class="btn btn-default" (click)="onCancelClicked()" ><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
		
    </div>
    </div>
</div>
<app-edit-view-gtin-dialog #editViewGtinDialog  (refreshParent)="refreshGtinDetail()"></app-edit-view-gtin-dialog>
<app-confirm-delete-dialog #confirmDeleteDialog *ngIf="showConfirm"
	(confirmEvent)="onConfirmDelete()"></app-confirm-delete-dialog>